import * as Yup from 'yup';
import { POTENTIAL_REDUCTION_ESTIMATED } from '../../../constants';

const FifthStepSchemaValidator = () => Yup.object().shape({
  benefitEstimator: Yup.object().shape({
    potentialReductionEstimated: Yup.number()
      .max(POTENTIAL_REDUCTION_ESTIMATED.MAX, ' max')
      .required('This field is required'),
  }),
});

export default FifthStepSchemaValidator;
